// extracted by mini-css-extract-plugin
export default {"root":"gcP6y","chained":"vj9ko","header":"wps4p","content":"oFdYx","own":"_8v7IK","pending":"I4T+p","avatar":"xYbZB","name":"XR92v","timeAgo":"gl+UI"};